import React, { useState } from 'react'
import styled from 'styled-components'
import SearchForm from './search-form.component'
import FontAwesome from 'react-fontawesome'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isMobile } from './../../helpers/window.helper'
import { breakpoints } from './../../constants/breakpoits.constants'
import { Creators as TicketSaleCreators } from '../../ducks/ticket-sale/ticket-sale'
import { history } from './../../helpers/history'
import { routes } from '../../constants/routes.constants'
import {
	HEADER_HEIGHT,
	SEARCHBAR_HEIGHT,
} from '../../layouts/styled-layout.style'

function renderCollapseButton(collapse) {
	return (
		<FontAwesome
			className="blue arrow-icon"
			name={collapse ? 'arrow-down' : 'arrow-up'}
		/>
	)
}

const StyledTextContainer = styled.div`
	font-size: 1.7rem;
	text-align: center;
	vertical-align: middle;
	padding: 20px 0;
	.arrow-icon {
		margin-left: 15px;
	}
`

const StyledContainer = styled.div`
	align-items: center;
	background: white;
	box-shadow: 0px 5px 10px -2px rgba(0, 0, 0, 0.3);
	display: flex;
	min-height: ${SEARCHBAR_HEIGHT}rem;
	position: ${isMobile() ? 'static' : 'fixed'};
	${({ top }) => (top !== undefined && top !== null ? `top: ${top};` : '')}
	width: 100vw;
	z-index: 3;
	justify-content: space-evenly;
	flex-direction: column;
	${({ logged }) =>
		logged !== undefined && logged !== null && logged == 'true'
			? `margin-top: ${isMobile() ? '0' : HEADER_HEIGHT - 9}rem;`
			: `margin-top: ${isMobile() ? '0px' : '20rem'}`}

	@media (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: column;
		${({ logged }) =>
			logged !== undefined && logged !== null && logged == 'true'
				? `margin-top: 57px;`
				: `margin-top: 12rem`}
	}

	.container-title-search-field {
		display: flex;
		position: relative;
		flex: 1;
		width: 100%;
		flex-direction: column;
		justify-content: space-around;
		transition: transform 1s;

		@media (min-width: ${breakpoints.MOBILE}px) {
			flex-direction: row;
		}
	}

	.is-align-center {
		transform: translateY(30px);
	}

	.rebooking-highlight {
		margin: 10px 0px;
		display: inline-block;
		animation: shake 2s;
		animation-iteration-count: 1;

		span {
			font-size: 16px;

			a {
				font-weight: bold;
				cursor: pointer;
			}
		}
	}

	.is-fade-out {
		animation: fadeOut 1s forwards;
	}

	.flex-container {
		padding: 0px 15px;
		width: 100%;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			padding: 0px;
		}
	}

	form {
		width: 100%;
		padding: 0px 20px;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			width: 70%;
			padding: 0px;
		}
	}
`

function TripSearchBar({ top, logged, resetRebookingData, isRebooking }) {
	var initialCollapseValue =
		isMobile() && location.pathname.includes('compra-de-passagem')
			? false
			: isMobile()
	const [collapse, setCollapse] = useState(initialCollapseValue)
	const [isLeavingRebooking, setIsLeavingRebooking] = useState(false)

	const hideSearchBar =
		location.pathname == '/' ||
		location.pathname.includes('muvicard/cadastro') ||
		location.pathname.includes('login-social/cadastro') ||
		location.pathname.includes('muvibus')

	const shouldNotCollapse = !(collapse && isMobile())

	const closeAfterResult = () => setCollapse(true)

	function handleClickOnLeaveRebooking() {
		setIsLeavingRebooking(true)
		resetRebookingData()

		setTimeout(() => {
			history.push('/cliente/minhas-compras')
		}, 1000)
	}

	return hideSearchBar ? null : (
		<StyledContainer top={top} logged={logged}>
			<div
				className={`container-title-search-field ${
					(isLeavingRebooking || !isRebooking) && 'is-align-center'
				}`}>
				<StyledTextContainer
					className="col-3 info-trip-bar"
					onClick={() => setCollapse(!collapse)}>
					<b className="blue">Compre aqui a sua passagem de ônibus!</b>
					{/* <br />
					<span className="f-small orange">
						Comprando ida e volta você ganha {roundTrip} pontos bônus!
					</span>  */}
					{isMobile() ? renderCollapseButton(collapse) : null}
				</StyledTextContainer>

				{shouldNotCollapse && (
					<SearchForm
						closeTripSearch={closeAfterResult}
						className="col-9 origin-destination-select"
					/>
				)}
			</div>
			{isRebooking && (
				<div
					className={`rebooking-highlight ${
						isLeavingRebooking && 'is-fade-out'
					}`}>
					<span>
						Você está remarcando uma passagem,{' '}
						<a onClick={() => handleClickOnLeaveRebooking()}>
							clique aqui
						</a>{' '}
						para sair da remarcação.
					</span>
				</div>
			)}
		</StyledContainer>
	)
}

const mapStateToProps = ({ bonusPoints, ticketSale }) => ({
	roundTrip: bonusPoints.roundTrip,
	isRebooking: ticketSale.rebookingData.isRebooking,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			resetRebookingData: TicketSaleCreators.resetRebookingData,
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(TripSearchBar)
